import { useState } from "react";
import { useAuthentication } from "../../../../Hooks/useAuthentication";
import AdminWeeklySalesReport from "../AdminWeeklySalesReport/AdminWeeklySalesReport";
import AdminCourierPayments from "../AdminCourierPayments/AdminCourierPayments";
import "./AdminPayments.css";

const TABS = [
  { key: "negocios", label: "🏬 Pagos a negocios" },
  { key: "repartidores", label: "🛵 Pagos a repartidores" },
];

export default function AdminPayments() {
  const { role } = useAuthentication();
  const isAdmin = ["admin", "administrador", "administrator"].includes(
    String(role || "").toLowerCase()
  );
  const [tab, setTab] = useState("negocios");

  if (!isAdmin) {
    return (
      <div className="container-fluid container-mh ap-page">
        <div className="alert alert-danger">Esta sección es solo para administradores.</div>
      </div>
    );
  }

  return (
    <div className="container-fluid container-mh ap-page">
      <h2 className="ap-title">💸 Pagos</h2>
      <p className="ap-subtext">Cuánto le debe el admin a negocios y a repartidores esta semana.</p>

      <div className="ap-tabs" role="tablist">
        {TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            role="tab"
            aria-selected={tab === t.key}
            className={`ap-tab ${tab === t.key ? "ap-tab--active" : ""}`}
            onClick={() => setTab(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="ap-tab-body">
        {tab === "negocios" && <AdminWeeklySalesReport />}
        {tab === "repartidores" && <AdminCourierPayments />}
      </div>
    </div>
  );
}
